import { createFileRoute } from '@tanstack/react-router';

import { SpaceListPage } from '../../../features/community-hub/components/space-list-page';

/**
 * Community Hub - Space List Route
 * Path: /community-hub
 *
 * Shows all parent spaces accessible to the current user
 */
export const Route = createFileRoute('/_protected/community-hub/')({
  component: SpaceListPage,
});
